import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { APP } from "@/constants/testIds";

export default function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50">
        <div
          data-testid={APP.loadingSpinner}
          className="w-8 h-8 border-2 border-orange-600 border-t-transparent rounded-full animate-spin"
        />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  if (adminOnly && user.role !== "amministratore") {
    return (
      <div className="p-10 max-w-lg mx-auto text-center">
        <h2 className="font-display text-2xl font-bold mb-2">Accesso riservato</h2>
        <p className="text-slate-600">Questa sezione è visibile solo agli amministratori.</p>
      </div>
    );
  }

  return children;
}
